export default "__VITE_ASSET__CL64wuEK__"